import { useEffect, useState } from "react";
import { useRestClientContext } from "../contexts/RestClientContext";
import { useTeamContext } from "../contexts/TeamContext";
import Client from "../rest/Client";
import { Group } from "../types/types";

export default function useTeamGroups() {
	const client: Client = useRestClientContext();
	const team = useTeamContext();

	const [loading, setLoading] = useState(false);
	const [groups, setGroups] = useState<Group[]>();

	useEffect(() => {
		setLoading(true);
		client
			.fetchGroups(team.id)
			.then((response: Response) => response.json())
			.then((json) => {
				setGroups(json);
				setLoading(false);
			})
			.catch(() => {
				setLoading(false);
				throw new Error("Failed to fetch groups");
			});
	}, [client, team.id]);

	return { loading, groups };
}
